var DEPRECATED_ICONS = ['Calculator', 'HousePercent', 'Letter', 'HouseOutside', 'PaperAirplane', 'Mountain'];
export { DEPRECATED_ICONS };